import Typography from '@mui/material/Typography'

import type { ManageEvent } from '../manage-events.slice'

type Props = {
  event: ManageEvent
}

let EventDetailHeader = ({ event }: Props) => (
  <Typography variant="h5" component="h1">
    {event.name}
  </Typography>
)

export default EventDetailHeader
